import "../styles/cards.scss";

export function HomeCard2(props) {
    const length = 40;
    const text = props.des.length > length ? props.des.substring(0, length) + "..." : props.des;
    return (
        <div className="homeCard2" >
            <div className="homeCard2Text"> {props.text}</div>
            <img  src={props.img} />
            <div className="homeCard2Des"> {text}</div>
            <div className="btnC" onClick={() => {
            window.location.href="detail?num=" + props.num
        }}> {props.btn}</div>
        </div>
    );
}
